import React from 'react';
import { UserMessage } from '../../DesignSystem/LiliUserMessage/UserMessage';
import { WizardWrapper } from './logic/WizardWrapper';
import { ChangePersonalAddressSteps } from './ChangePersonalAddressSteps';
import { errorCodesEnum } from './logic/useStepHook';

export interface ChangePersonalAddressProps {
  onClose: () => void;
  businessFlow: boolean;
}

export interface ApiError {
  code: number;
}
export interface ErrorData {
  errorMessage?: string;
  errorCode?: number;
  errorKey: errorCodesEnum;
  prevStep?: number;
  inlineError?: boolean;
}
export interface IPayload {
  error?: ErrorData;
  apiResponseData?: string;
  step?: number;
}
export interface ChangePersonalAddressData {
  type: string;
  step?: number;
  error?: ErrorData;
}

export const ChangePersonalAddress = ({ onClose, businessFlow }: ChangePersonalAddressProps) => (
  <div>
    <UserMessage id='change-Address-modal' onClick={onClose} shouldPersist shouldBlur>
      <WizardWrapper>
        <ChangePersonalAddressSteps onClose={onClose} businessFlow={businessFlow} />
      </WizardWrapper>
    </UserMessage>
  </div>
);
